<template>
  <v-container grid-list-md class="px-0">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card flat text class="mt-4 px-2">
          <v-row wrap class="ml-1">
            <v-col cols="12" sm="10" md="10" lg="10" class="title font-weight-bold">Riwayat Peserta</v-col>
            <v-col cols="12" sm="10" md="10" lg="10" class="pb-0">
              <v-text-field
                outlined
                dense
                autocomplete="false"
                name="Alamat Surel Pengguna"
                placeholder="Masukkan alamat surel pengguna yang akan dicari"
                label="Surel"
                v-model="user.email"
                persistent-hint
                @keyup.13.prevent="checkUser"
                data-vv-name="email"
                data-vv-as="Surel"
                :error-messages="errors.collect('form.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2">
              <m-button text-button="Cari" icon="mdi-magnify" action="checkUser" @checkUser="checkUser"></m-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="detil && detil.name">
        <m-card title="Detil Pengguna">
          <v-row wrap>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2 text-center">
              <v-card text color="#fff" flat>
                <v-container fill-height container--fluid>
                  <v-row fill-height>
                    <v-col class="text-center" cols="12" align-end colbox>
                      <v-avatar :size="125" color="blue lighten-5">
                        <v-img
                          fluid
                          :src="
                            detil.kelamin == 'L'
                              ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                              : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                          "
                        ></v-img>
                      </v-avatar>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <v-list>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Nama</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "name") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Sekolah</v-list-item-subtitle>
                        <div class="black--text body-1">
                          <p class=" orange--text mb-0 pb-0 font-weight-bold">{{ pVal(detil, "sekolah_id") }}</p>
                          {{ pVal(detil, "nama_sekolah") }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="12" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Surel</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "email") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">Komunitas</v-list-item-subtitle>
                        <div class="black--text body-1">{{ pVal(detil, "komunitas") }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
              <v-data-table :headers="headers" :items="detil.kelasenrol" :items-per-page="10" item-key="id">
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <p class="subtitle-1 font-weight-bold black--text my-0 py-0">{{ pVal(item.instansi, "nama") }}</p>
                      </td>
                      <td>
                        <p class="subtitle-1 font-weight-bold black--text my-0 py-0">{{ pVal(item, "sekolah_id") }}</p>
                      </td>
                      <td>
                        <p class="subtitle-1 primary--text my-0 py-0">{{ pVal(item.kelas, "nama") }} ({{ pVal(item.kelas, "angkatan") }})</p>
                      </td>
                      <td>
                        <p class="subtitle-1 primary--text my-0 py-0">
                          <m-chip :color="$kelas.statusColor(item.kelas.status_id)" :title="item.kelas.status_id == 1 ? 'DRAFT' : 'TERBIT'" />
                        </p>
                      </td>
                      <td v-if="item.progress">
                        <p class="subtitle-1 black--text my-0 py-0" v-if="item.progress.length">{{ item.progress[0] ? item.progress[0].percentage : 0 }}%</p>
                      </td>
                      <td v-else>
                        <span class="grey--text">Tidak Tersedia</span>
                      </td>
                      <td>
                        <m-button :disabled="!item.is_complete" text-button="Sertifikat" icon="mdi-file" action="toSertifikat" @toSertifikat="toSertifikat(item)"></m-button>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
    </v-row>
    <SertifikatDialog ref="dlgSertifikat" />
  </v-container>
</template>

<script>
export default {
  components: {
    SertifikatDialog: () => import("../../kelas/components/SertifikatDialog")
  },
  data() {
    return {
      user: {
        email: null,
        username: null,
        kode_aktivasi: null
      },
      defUser: {
        name: null,
        email: null,
        username: null,
        kode_aktivasi: null,
        kelasenrol: []
      },
      detil: null,
      headers: [
        { text: "Seri", align: "left", value: "", sortable: false },
        { text: "Kode Sekolah", align: "left", value: "", sortable: false },
        { text: "Nama Kelas", align: "left", value: "", sortable: false },
        { text: "Status Kelas", align: "left", value: "", sortable: false },
        { text: "Progress", align: "left", value: "", sortable: false },
        { text: "Sertifikat", align: "left", value: "", sortable: false }
      ]
    };
  },
  mounted() {
    this.detil = this.defUser;
  },
  methods: {
    toSertifikat(o) {
      this.$refs.dlgSertifikat
        .open(o.is_complete, o.instansi_id, o)
        .then(() => {
          this.getCourse();
        })
        .catch(e => e);
    },
    checkUser() {
      return this.$store
        .dispatch("user/search", this.user.email)
        .then(res => {
          if (res.id) {
            this.detil = { ...res };
          } else {
            this.$error("Akun tidak ditemukan");
            this.detil = null;
          }
        })
        .catch(e => e);
    }
  }
};
</script>
